import { Inject, Injectable, Optional, InjectionToken } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import type { TranslationTable } from '@app/shared/dg-translate-loader';
import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, EMPTY } from 'rxjs';
import { tap } from 'rxjs/operators';

export const LazyTranslationBundleToken = new InjectionToken(
  'LazyTranslationBundle'
);

@Injectable()
export class LazyTranslationBundleResolver implements Resolve<void> {
  private load: Observable<any>;

  constructor(
    private translate: TranslateService,
    private http: NgxHttpClient,
    @Optional()
    @Inject(LazyTranslationBundleToken)
    private bundleKey: string
  ) {}

  public resolve(): Observable<void> {
    if (!this.bundleKey) {
      return EMPTY;
    }

    if (!this.load) {
      // Load channel bundle for all current active languages
      const langs = this.translate.langs;
      this.load = forkJoin(
        langs.map((lang) => {
          return this.http
            .get<TranslationTable>('/translations/translate', {
              params: {
                format: 'Json',
                culture: lang,
                bundle: this.bundleKey,
              },
            })
            .pipe(
              tap((translationTable) => {
                this.translate.setTranslation(lang, translationTable, true);
              })
            );
        })
      );
    }

    return this.load;
  }
}
